import { BehaviorSubject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class OutboundService {
  refreshDetails = new BehaviorSubject<boolean>(false);

  constructor(private http: HttpClient) { }

  getAll(params: any): any {
    return this.http.get(`${environment.apiStock}/OutboundNote/GetAllOutboundWithSize`, { params });
  }

  filterDefinitionOutbound() {
    return this.http.get(`${environment.apiStock}/OutboundNote/FilterDefinitionOutbound`);
  }

  saveRecord(data: any) {
    return this.http.post(`${environment.apiStock}/OutboundNote/CreateOutbound`, data);
  }

  getDetails(id: number) {
    return this.http.get(`${environment.apiStock}/OutboundNote/OutboundNoteDetails/${id}`);
  }

  getOutboundNoteDefinition() {
    return this.http.get(`${environment.apiStock}/OutboundNote/OutboundNoteDefinition`);
  }

  outboundAddList(data: any) {
    return this.http.post(`${environment.apiStock}/OutboundNote/OutboundAddList`, data);
  }

  getConsigneePartners(id: number) {
    return this.http.get(`${environment.apiStock}/OutboundNote/GetConsigneePartners/${id}`);
  }

  importFile(data: any) {
    return this.http.post(`${environment.apiStock}/OutboundNote/ImportExcelFile`, data);
  }

  importSimpleSheet(data: any) {
    return this.http.post(`${environment.apiStock}/OutboundNote/ImportSimpleSheet`, data);
  }

  downloadFile() {
    return this.http.get(`${environment.apiStock}/OutboundNote/DownloadFile`, { responseType: 'blob' });
  }

  getCustomerList() {
    return this.http.get(`${environment.apiStock}/OutboundNote/GetCustomerList`);
  }

  createQuickDN(data: any) {
    return this.http.post(`${environment.apiStock}/DispatchNote/CreateQuickDN`, data);
  }

  cancelOutboundNote(data: any) {
    return this.http.post(`${environment.apiStock}/OutboundNote/CancelOutboundNote`, data);
  }
}
